module.exports = __webpack_public_path__ + "img/cargando.d72cbded.gif";